import i18n from 'shared/lib/i18n';

export const paymentsURL = '/external-accounts-v1/payment-account';
export const accessControlURL = '/external-accounts-v1/access-control-account';
export const camerasURL = '/external-accounts-v1/camera-account';
export const customIntegrationsURL =
  '/external-accounts-v1/custom-integrations';

export const ACCOUNT_TYPE = {
  external_payments: 'external-payments-accounts',
  aptexx: 'aptexx',
  brivo: 'brivo',
  clickpay: 'clickpay',
  comelit: 'comelit',
  eagleeye: 'eagleeye',
  smartair: 'smartair',
  two_n: '2n',
  akuvox: 'akuvox',
  bmx: 'bmx',
  dormakaba: 'dormakaba',
  lyazon: 'lyazon',
  zerv: 'zerv',
  salto: 'salto',
  keyscan: 'keyscan',
};

export const getIntercomButtonLevelOptions = () => [
  {
    value: 'unit',
    label: i18n.t('externalAccounts.intercomButtonLevelOptions.unit'),
  },
  {
    value: 'unit_resident_initials',
    label: i18n.t(
      'externalAccounts.intercomButtonLevelOptions.unit_resident_initials',
    ),
  },
  {
    value: 'unit_resident_full_last_name',
    label: i18n.t(
      'externalAccounts.intercomButtonLevelOptions.unit_resident_full_last_name',
    ),
  },
  {
    value: 'unit_last_name_first_initial',
    label: i18n.t(
      'externalAccounts.intercomButtonLevelOptions.unit_last_name_first_initial',
    ),
  },
  {
    value: 'resident_full_last_name',
    label: i18n.t(
      'externalAccounts.intercomButtonLevelOptions.resident_full_last_name',
    ),
  },
  {
    value: 'resident_full_last_name_ln_first',
    label: i18n.t(
      'externalAccounts.intercomButtonLevelOptions.resident_full_last_name_ln_first',
    ),
  },
  {
    value: 'full_first_name_last_initial',
    label: i18n.t(
      'externalAccounts.intercomButtonLevelOptions.full_first_name_last_initial',
    ),
  },
];

export const getDuplicatesResolutionMethods = () => [
  {
    value: 'minimum_required_letters',
    label: i18n.t(
      'externalAccounts.duplicatesResolutionMethods.minimum_required_letters',
    ),
  },
  {
    value: 'full_name',
    label: i18n.t('externalAccounts.duplicatesResolutionMethods.full_name'),
  },
];

export const getOpeningMethod = () => ({
  BRIVO: [{ label: i18n.t('title.online'), value: 'online' }],
  SMARTAIR: [
    { label: i18n.t('title.all'), value: 'all' },
    { label: i18n.t('title.online'), value: 'online' },
    { label: i18n.t('title.bluetooth'), value: 'bt' },
  ],
  COMELIT: [{ label: i18n.t('title.online'), value: 'online' }],
  TWO_N: [{ label: i18n.t('title.online'), value: 'online' }],
  AKUVOX: [{ label: i18n.t('title.online'), value: 'online' }],
  BMX: [{ label: i18n.t('title.online'), value: 'online' }],
  DORMAKABA: [{ label: i18n.t('title.bluetooth'), value: 'bt' }],
  LYAZON: [{ label: i18n.t('title.bluetooth'), value: 'bt' }],
  ZERV: [{ label: i18n.t('title.online'), value: 'online' }],
  SALTO: [
    { label: i18n.t('title.all'), value: 'all' },
    { label: i18n.t('title.online'), value: 'online' },
    { label: i18n.t('title.bluetooth'), value: 'bt' },
  ],
  KEYSCAN: [
    { label: i18n.t('title.all'), value: 'all' },
    { label: i18n.t('title.online'), value: 'online' },
    { label: i18n.t('title.bluetooth'), value: 'bt' },
  ],
});
